angular.module('qkr.merchant.reports')
    .controller('ScheduleMerchantReportsController', function ($uibModal, merchantInfo, $routeSegment, outletService) {

        const vm = this;

        vm.scheduleTransactionsReport = function () {
            const accountancyPackageName = merchantInfo.accountancyPackage ? merchantInfo.accountancyPackage.name : '';

            const modalInstance = $uibModal.open({
                template: require('./transaction.merchant.html'),
                controller: 'TransactionMerchantController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    reportInfo() {
                        return {
                            reportType: accountancyPackageName
                        };
                    },
                    savedReport() {
                        return null;
                    },
                    outlets() {
                        return outletService.listOutlets();
                    }
                }
            });

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };

        vm.schedulePerkReport = function () {
            const modalInstance = $uibModal.open({
                template: require('./perk.html'),
                controller: 'PerkController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    savedReport() {
                        return null;
                    }
                }
            });

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };

    });



// WEBPACK FOOTER //
// ./src/reports/merchant/schedule/schedule.controller.js